import { shortRingNumber } from "@breenova/domain";
import { useParams } from "react-router";

import { DetailHeader } from "@/components/app-shell";
import { useBird } from "@/lib/birds";
import { PedigreeTab } from "@/routes/birds/pedigree-tab";

/**
 * A bird's pedigree on a screen of its own.
 *
 * Its own screen rather than a tab under the photo: a tree wants the height, and the
 * header — back to the bird, with the ring number above the word "Pedigree" — keeps the
 * reader sure whose ancestors these are while they follow a line out to the right.
 */
export function BirdPedigreePage() {
  const { id } = useParams<{ id: string }>();
  const bird = useBird(id);
  const ring = bird.data?.ringNumber;

  return (
    <div className="flex flex-col">
      <DetailHeader
        kicker={ring ? shortRingNumber(ring) : undefined}
        title="Pedigree"
        backTo={`/birds/${id ?? ""}`}
      />
      {id ? <PedigreeTab birdId={id} /> : null}
    </div>
  );
}
